<template lang="html">
  <div class="listado-recetas wrapper">
    <section class="intro-receta row-center">
      <span
        v-for="(cat, key) in categoriesRecipes"
        class="background"
        :cat-slug='cat.slug'
        :active="catSelected == cat.slug"
        :style="`background-image:url(${cat.banner_image.url})`"
        :key="key"
      ></span>

      <nav class="categorias" v-if="showSelect">
        <div class="container row-between">
          <router-link
            to="/recetas"
            :active="catSelected == ''"
            @click="selectCat('')"
            >Todas</router-link
          >

          <router-link
            :to="'/recetas/?' + categoria.slug"
            :active="catSelected == categoria.slug"
            v-for="(categoria, key) in categoriesRecipes"
            v-html="categoria.name"
            @click="selectCat(categoria.slug)"
            :key="key"
          ></router-link>
        </div>
      </nav>

      <div v-else class="contenedor-select">
        <select v-model="catSelected">
          <option value="">Todas</option>
          <option
            v-for="(categoria, key) in categorias"
            :value="categoria.slug"
            >{{ categoria.nombre }}</option
          >
        </select>
      </div>
    </section>

    <section class="recetas-list-container">
              <h1 v-if="catSelected=='aperitivos'" class="hand-title">Recetas para Aperitivos con Espárragos Carretilla</h1>
              <h1 v-if="catSelected=='veganas'" class="hand-title">Recetas Veganas con Espárragos Carretilla</h1>
              <h1 v-if="catSelected=='ocasiones-especiales'" class="hand-title"> Recetas para Ocasiones Especiales con Espárragos Carretilla</h1>
              <h1 v-if="catSelected=='cocina-facil'" class="hand-title"> Recetas Fáciles con Espárragos Carretilla</h1>
              <h1 v-if="catSelected=='en-familia'" class="hand-title">Recetas en familia con Espárragos Carretilla</h1>
              <h1 v-if="catSelected=='ligeras'" class="hand-title">Recetas ligeras con Espárragos Carretilla</h1>



      <div class="buscador column-center">
        <label for="buscador" class="hand-title">Buscar Recetas Carretilla por Ingrediente</label>
        <input
          type="text"
          v-model="textSearch"
          id="searchTool"
          @keyup.enter="search"
          placeholder="Escribe el ingrediente a buscar"
        />
      </div>

      <p class="listado-recetas -resultados" v-if="recipes.length > 0">
        Se están mostrando
        {{ recipes.length }} resultados {{ namecatSelected }}
      </p>

      <p
        class="listado-recetas -resultados"
        v-if="(recipes.length > 0) & (categoriesRecipes.length > 0)  && (textSearch != '')" >
        Puedes encontrar en otras categorías recetas con este ingrediente.
      </p>

      <div class="container row-start recetas-list">
        <template v-if="recipes.length != 0">
          <receta-el
            :data="receta"
            v-for="(receta, key) in recipes"
            :key="key"
          ></receta-el>
        </template>
        <div v-else class="column-center error-busqueda">
          <p class="hand-title">Lo sentimos</p>
          <p>
            En estos momentos no tenemos recetas con tus criterios de búsqueda,
            pero muy pronto las tendremos.
          </p>
          <p class="hand-title -dorado">¡Permanece atento!</p>
          <a class="btn-ver-recetas" href="javascript:location.reload()"
            >Ver recetas</a
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="js">

import receta from '@/components/parts/receta-el'

import axios from 'axios';
import VueAxios from 'vue-axios';

import { mapGetters, mapActions } from "vuex";



export default {
  name: 'listado-recetas',
  props: [],
  mounted() {
    this.seleccionarCategoria();
    this.setFixedCategoria();
    //this.getData();
    this.setData();
    $(window).scroll(e => {
      this.setFixedCategoria();
    });

  },
  data() {
    return {
      recetas: '',
      categorias: '',
      catSelected: '',
      textSearch: '',
      showerror: '',
      recipes : [],
      categoriesRecipes : []
    }
  },

  methods: {
    ...mapActions(["requestReceta" , "requestCategories"]),
      setData() {
        this.requestCategories(data).then((r) => {
          this.categoriesRecipes = r.data;
        });
        let data = {
          // length: (this.actualPage == 1 ) ? 6: 6,
          //length: 6,
          page: this.actualPage,
          order: [
            {
              name: "created_at",
              direction: "desc",
            },
          ],

          filters: [
           {
             name: "name",
             search: this.textSearch,
             textFilter: 1,
           },
           {
            name: "category.slug",
            search: this.catSelected,
            textFilter: 1,
          },

          ],
          columns:[
            {
              name: "category",
              onlyLoad: true
            }
          ]

        };

        this.loading = true;

        this.requestReceta(data).then((r) => {
          this.recipes = r.data;
          this.loading = false;
          this.total = r.recordsFiltered;
        });
      
      },
       search(){
      this.actualPage = 1;
      this.setData();
    },
    // getData: function () {
    //   this.recetas = recetas;
    //   this.categorias = categorias;
    // },
    selectCat: function (cat) {
     this.setData();
    },


    setCategorie: function () {
      // console.log(this.$route.params.id);
      if (!!this.$route.hash) {

        // this.$route.params.cat =
        this.catSelected = this.$route.hash.substring(1);
      }
    },
    setFixedCategoria: function () {

      let top = $(window).scrollTop();

      let LIMIT = ($(window).width() * 0.40) - 260;

      (top >= LIMIT) ? $(".listado-recetas").addClass('fixed') : $(".listado-recetas").removeClass('fixed');
    },
    seleccionarCategoria: function () {
      let cat = location.search.split("?").pop();
      this.catSelected = cat;

      if (!!this.categorias) {

        let description;
        let title;

        if (!!this.getTexts.textos_categorias_titles[cat]) {
          title = this.getTexts.textos_categorias_titles[cat]
        } else {
          title = this.getTexts.textos_categorias_titles['defecto'];
        }

        if (!!this.getTexts.textos_categorias_description[cat]) {
          description = this.getTexts.textos_categorias_description[cat]
        } else {
          description = this.getTexts.textos_categorias_description['defecto'];
        }
        document.title = title;
        document.head.querySelector("[name=title]").content = title;
        document.head.querySelector("[name=description]").content = description;
      }

    }
  },
  computed: {
    recetasfiltered: function () {
      let recetas = new Array();

      if (!!this.recetas) {

        if (!!this.catSelected) {

          this.recetas.forEach(el => {
            if (el.categorias.some(cat => cat.slug == this.catSelected)) {
              recetas.push(el);
            }
          });

        } else {
          recetas = this.recetas.slice();
        }



        if (this.search.length > 2) {

          let search = this.search.normalize('NFD').replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize();
          recetas = recetas.filter(r => {
            return (r.ingredientes.toLowerCase().includes(search.toLowerCase()));
          })
        }


      }

      return recetas;
    },
    allrecetasfiltered() {

      let recetas = new Array();

      if (!!this.recetas) {

        if (this.search.length > 2) {

          recetas = this.recetas.filter(r => {
            return (r.ingredientes.toLowerCase().includes(this.search.toLowerCase()));
          })
        }

      }

      return recetas;

    },
    showSelect: function () {

      var show = ($(window).width() >= 910);

      return show;
    },
    namecatSelected() {
      let cat;
      if (!!this.catSelected) {
        cat = 'de la categoria ' + this.categoriesRecipes.filter(c => c.slug == this.catSelected)[0].name;
      }else{
        cat = ''
      }
      return cat;
    },
    ...mapGetters(['getServer', 'getLanguage', 'getTexts'])


  },
  components: {
    'receta-el': receta
  },
  watch: {
    '$route': function () {
      this.seleccionarCategoria();
      this.setData();
    },

    'getLanguage': function () {
      this.getData();
    },
     'textSearch'(){
      if(this.textSearch == ""){
        this.actualPage = 1;
        this.noticia = [];
        this.setData();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.intro-receta {
  overflow: hidden;
  height: 25vw;
}

.intro-receta h2 {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  font-size: 42px;
  z-index: 3;
}

.background {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  opacity: 0;
  transition: 1s;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /*  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  animation-name: zoom;
  animation-duration: 30s;
  animation-fill-mode: forwards;*/
}

@keyframes zoom {
  50% {
    transform: perspective(500px) translateZ(100px);
  }

  100% {
    transform: perspective(500px) translateZ(0px);
  }
}

.background[active="true"] {
  opacity: 1;
}

.recetas-list {
  padding-top: 0px;
  padding-bottom: 50px;
}

.categorias,
.intro-receta .contenedor-select {
  position: absolute;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  width: 100%;
  z-index: 5;
  transition: 2s;
  padding: 10px;
  padding-bottom: 0;
}

.intro-receta .contenedor-select::before {
  content: "";
  border: 6px solid transparent;
  display: inline-block;
  border-top-color: #967842;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateX(-50%);
}

.intro-receta select {
  height: 50px;
  padding: 0 20px;
  font-size: 20px;
  color: #202c54;
  font-weight: 800;
  border: none;
  width: 100%;
  background: transparent;
  border: 1px solid #967842;
  border-radius: 0;
}

.fixed .intro-receta {
  position: fixed;
  bottom: auto;
  top: 0px;
  height: 200px;
  z-index: 7;
}

.fixed .categorias {
  background: rgba(255, 255, 255, 1);
}

.fixed .categorias button {
  height: 60px;
}

.recetas-list-container {
  margin-top: 70px;
}

.categorias a {
  height: 60px;
  display: inline-block;
  font-family: "flower_power_personal_useRg";
  font-size: 18px;
  padding: 0 20px;
  background: none;
  outline: none;
  border: none;
  color: #212c55;
  border-bottom: 2px solid transparent;
  position: relative;
  cursor: pointer;
  line-height: 60px;
}

.categorias.fixed a {
  height: 60px;
}

.categorias a[active="true"] {
  border-bottom-color: #967842;
  color: #967842;
}

.categorias a[active="true"]::before {
  border: 10px solid transparent;
  display: inline-block;
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  border-bottom-color: #967842;
}

.fixed .recetas-list-container {
  padding-top: 610px;
}

.listado-recetas {
  width: 100%;
  display: inline-block;
}

.intro-receta select::before {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 100%;
  height: 100%;
  border: 1px solid #967842;
  content: "";
  display: inline-block;
}

@media screen and (max-width: 910px) {
  .fixed .recetas-list-container {
    padding-top: 180px;
  }
}

@media screen and (max-width: 600px) {
  .fixed .recetas-list-container {
    padding-top: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/listado-recetas.vue